<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="8">
        <v-text-field
          dense
          outlined
          hide-details
          label="Nome"
          class="required rounded-tag-small"
          :error="$v.fornecedorCadastro.nome.$error"
          @blur="$v.fornecedorCadastro.nome.$touch()"
          v-model="fornecedorCadastro.nome"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          dense
          outlined
          hide-details
          label="Código interno"
          class="rounded-tag-small"
          v-model="fornecedorCadastro.codigoInterno"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="9">
        <v-textarea
          outlined
          auto-grow
          class="rounded-tag-small"
          label="Observações internas"
          counter="1500"
          rows="1"
          v-model="fornecedorCadastro.observacoesInternas"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <px-switch-tooltip
          v-model="fornecedorCadastro.permiteEdicaoCotacao"
          label="Editar cotações"
          tooltip="Habilita a edição das respostas submetidas por este fornecedor no<br>
            processo de cotação, desde que não possua negociação em aberto."/>
      </v-col>
    </v-row>
    <px-cadastro-endereco-internacional v-if="!isPessoaFisica"
                                        ref="internacional"
                                        :endereco="fornecedorCadastro.endereco"/>
    <px-cadastro-endereco-nacional v-if="isPessoaFisica"
                                   ref="nacional"
                                   :endereco="fornecedorCadastro.endereco"/>
    <v-row dense class="mt-3">
      <v-col cols="12">
        <v-subheader class="grey lighten-4 text--primary">
          <v-icon left>mdi-phone</v-icon>
          Contatos
        </v-subheader>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6">
        <px-cadastro-fornecedor-emails ref="emails"
                                       :fornecedor-cadastro="fornecedorCadastro"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-cadastro-fornecedor-telefones ref="telefones"
                                          :nacional="isPessoaFisica"
                                          :fornecedor-cadastro="fornecedorCadastro"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn color="primary"
               class="rounded-tag-small normal-btn-text elevation-0"
               :loading="loadingSave"
               @click="onClickSalvar">
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import CadastroFornecedorEmails
  from '@/modules/gestao-fornecedor/gestao/cadastro/CadastroFornecedorEmails.vue';
import CadastroFornecedorTelefones
  from '@/modules/gestao-fornecedor/gestao/cadastro/CadastroFornecedorTelefones.vue';
import { TipoFornecedor } from 'px-business-components';
import validationMixin from '@/mixins/validation-mixin';
import { onlyNumbers } from '@/utils/regex-utils';
import GestaoFornecedorService from '../../gestao-fornecedor-service';

export default {
  mixins: [validationMixin],
  props: {
    fornecedor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fornecedorCadastro: {
        endereco: {
          estado: null,
          municipio: null,
          mesorregiao: null,
          cep: null,
          rua: null,
          numero: null,
          complemento: null,
          bairro: null,
          pais: null,
          codigoPostal: null,
          provincia: null,
          cidade: null,
        },
        nome: null,
        codigoInterno: null,
        observacoesInternas: null,
        permiteEdicaoCotacao: true,
        emails: [],
        contatosWhatsapp: [],
      },
      loadingSave: false,
    };
  },
  computed: {
    isPessoaFisica() {
      return this.fornecedor.tipoFilho === TipoFornecedor.keys.PESSOA_FISICA.key;
    },
  },
  methods: {
    validarFormEDependencias() {
      const emails = this.$refs.emails.validate();
      const telefones = this.$refs.telefones.validate();
      const endereco = this.isPessoaFisica
        ? this.$refs.nacional.validateForm() : this.$refs.internacional.validateForm();
      return emails || telefones || endereco || this.validateForm();
    },
    emitOnLoading(loading) {
      this.$emit('loading', loading);
    },
    onClickSalvar() {
      this.$emit('before-save', this.fornecedorCadastro);
      if (this.validarFormEDependencias()) {
        return;
      }
      this.salvar();
    },
    buildPayload() {
      const fornecedor = { ...this.fornecedorCadastro };
      return {
        ...fornecedor,
        disabled: false,
        tipo: this.fornecedor.tipo,
        tipoFilho: this.fornecedor.tipoFilho,
        pessoa: {
          nome: fornecedor.nome,
          nomeReceita: fornecedor.nome,
          documento: this.isPessoaFisica
            ? onlyNumbers(this.fornecedor.documento) : this.fornecedor.documento,
        },
        contatosWhatsapp: fornecedor.contatosWhatsapp,
        emails: fornecedor.emails.map(e => e.value),
      };
    },
    salvar() {
      this.loadingSave = true;
      this.emitOnLoading(this.loadingSave);

      GestaoFornecedorService.saveFornecedorGestao(this.buildPayload())
        .then((content) => {
          this.$toast('Fornecedor salvo com sucesso!', { color: 'success' });
          this.$router.push({
            name: 'main.gestao-fornecedores.fornecedor',
            params: { id: content.data.idDetalhes },
          });
        })
        .finally(() => {
          this.loadingSave = false;
          this.emitOnLoading(this.loadingSave);
        });
    },
  },
  validations: {
    fornecedorCadastro: {
      nome: {
        required,
      },
    },
  },
  components: {
    pxCadastroFornecedorEmails: CadastroFornecedorEmails,
    pxCadastroFornecedorTelefones: CadastroFornecedorTelefones,
  },
};
</script>
